<template>
  <f7-page class="page-review-random-number">
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <f7-link panel-open="left" icon-ios="f7:menu"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>TẠO SỐ NGẪU NHIÊN</f7-nav-title>
    </f7-navbar>
    <f7-block inset strong>
      <f7-row>
        <f7-col class="text-align-center">
          <h1 class="result" v-html="number"></h1>
        </f7-col>
      </f7-row>
      <f7-row no-gap>
        <f7-col>
          <f7-list class="mt-0 mb-2">
            <f7-list-input
                outline
                floating-label
                label="Số bắt đầu"
                type="number"
                :value="min"
                @input="min = !!$event.target.value ? parseFloat($event.target.value) : 0">
            </f7-list-input>
          </f7-list>
        </f7-col>
        <f7-col>
          <f7-list class="mt-0 mb-2">
            <f7-list-input
                outline
                floating-label
                label="Số kết thúc"
                type="number"
                :value="max"
                @input="max = !!$event.target.value ? parseFloat($event.target.value) : 0">
            </f7-list-input>
          </f7-list>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col>
          <f7-button fill @click.prevent="getRandomNumber">
            TẠO SỐ
          </f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </f7-page>
</template>
<style scoped>
h1.result{
  font-size: 50px;
}
</style>
<script>
import {mapState} from 'vuex';

export default {
  data(){
    return {
      min           :1,
      max           :10,
      number        :1,
      intervalNumber:null
    }
  },
  computed:{
    ...mapState(['user_info']),
    userAgent(){
      return navigator.userAgent;
    }
  },
  methods :{
    loadNum        :function(){
      this.min = 1;
      this.max = 10;
      this.getRandomNumber();
    },
    getInput       :function(){
      let min = Number(this.min)
      let max = Number(this.max)
      if(min > max){
        [min, max] = [max, min]
      }
      this.min = min
      this.max = max
      this.getRandomNumber()
    },
    getRandomNumber:function(){
      const self = this;
      self.intervalNumber = setInterval(function(){
        self.number = self.generateNumber()
      }, 50);
      setTimeout(function(){
        clearInterval(self.intervalNumber);
      }, 3000);
    },
    generateNumber :function(){
      return Math.floor(Math.random() * (this.max - this.min + 1) + this.min);
    }
  },
  mounted(){

  }
};
</script>
